import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const QUICK = [
  { key: "1d", label: "1 Gün", days: 1 },
  { key: "7d", label: "7 Gün", days: 7 },
  { key: "15d", label: "15 Gün", days: 15 },
  { key: "1m", label: "1 Ay", months: 1 },
  { key: "2m", label: "2 Ay", months: 2 },
  { key: "3m", label: "3 Ay", months: 3 },
  { key: "6m", label: "6 Ay", months: 6 },
  { key: "1y", label: "1 Yıl", years: 1 },
  { key: "2y", label: "2 Yıl", years: 2 },
];

export function rangeFor(q) {
  const end = new Date();
  const start = new Date();
  if (q.days) start.setDate(start.getDate() - (q.days - 1));
  if (q.months) start.setMonth(start.getMonth() - q.months);
  if (q.years) start.setFullYear(start.getFullYear() - q.years);
  const fmt = (d) => d.toISOString().slice(0, 10);
  return { start: fmt(start), end: fmt(end) };
}

export function defaultGranularity(start, end) {
  const days = (new Date(end) - new Date(start)) / 86400000;
  if (days <= 45) return "day";
  if (days <= 200) return "week";
  return "month";
}

export default function DateRangeFilter({ value, onChange, testidPrefix = "date-filter" }) {
  const [mode, setMode] = useState("7d");
  const [custom, setCustom] = useState(false);
  const [cs, setCs] = useState(value.start);
  const [ce, setCe] = useState(value.end);

  const pick = (q) => {
    setMode(q.key); setCustom(false);
    onChange(rangeFor(q));
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`${testidPrefix}-container`}>
      {QUICK.map((q) => (
        <Button key={q.key} size="sm" variant={mode === q.key && !custom ? "default" : "outline"}
          data-testid={`${testidPrefix}-quick-${q.key}`} onClick={() => pick(q)}
          className="h-8 px-2.5 text-xs">
          {q.label}
        </Button>
      ))}
      <Button size="sm" variant={custom ? "default" : "outline"} data-testid={`${testidPrefix}-custom-toggle`}
        className="h-8 px-2.5 text-xs"
        onClick={() => { setCustom(true); setMode(""); }}>
        Özel Tarih
      </Button>
      {custom && (
        <div className="flex items-center gap-1.5">
          <Input type="date" value={cs} data-testid={`${testidPrefix}-custom-start`}
            onChange={(e) => setCs(e.target.value)} className="h-8 w-36 text-xs" />
          <span className="text-muted-foreground text-xs">—</span>
          <Input type="date" value={ce} data-testid={`${testidPrefix}-custom-end`}
            onChange={(e) => setCe(e.target.value)} className="h-8 w-36 text-xs" />
          <Button size="sm" data-testid={`${testidPrefix}-custom-apply`} className="h-8 text-xs"
            onClick={() => onChange({ start: cs, end: ce })}>Uygula</Button>
        </div>
      )}
    </div>
  );
}
